import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const superAdmin: RouteRecordRaw = {
  name: 'admin.superAdmin',
  path: 'SuperAdmin',
  component: () => import('pages/SuperAdminV2.vue'),
  meta: {
    roles: [Roles.SuperAdmin],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
  children: [
    {
      name: 'admin.superAdmin.plan.create',
      path: 'plan/create',
      component: () => import('components/learn/plan/LessonPlanForm.vue'),
      meta: {
        roles: [Roles.SuperAdmin],
      },
    },
    {
      name: 'admin.superAdmin.plan.edit',
      path: 'plan/:planId',
      component: () => import('components/learn/plan/LessonPlanForm.vue'),
      meta: {
        roles: [Roles.SuperAdmin],
      },
    },
    {
      name: 'admin.superAdmin.plan.view',
      path: 'plan/:planId/view',
      component: () =>
        import('components/learn/plan/readonly/LessonPlanReadonlyView.vue'),
      meta: {
        roles: [Roles.SuperAdmin],
      },
    },
  ],
}
